import { BaseApi } from '@smorder/logic';

class OrderApi extends BaseApi {
  * loadOrders() {
    return yield this.authorizedFetch('/api/v1/orders', {
      method: 'GET',
    });
  }

  * loadOrder(orderId) {
    return yield this.authorizedFetch(`/api/v1/orders/${orderId}`, {
      method: 'GET',
    });
  }

  * proceedOrder(orderId) {
    return yield this.authorizedFetch(`/api/v1/order/${orderId}/state`, {
      method: 'POST',
      parseAsText: true,
    });
  }

  * printOrder(orderId, type) {
    return yield this.authorizedFetch(`/api/v1/order/${orderId}/print?type=${type}`, {
      method: 'PUT',
      parseAsText: true,
    });
  }

  * declineOrder({ order, note, blockUser }) {
    return yield this.authorizedFetch(`/api/v1/order/${order.id}`, {
      method: 'DELETE',
      body: JSON.stringify({ Note: note, LockUser: blockUser }),
      parseAsText: true,
    });
  }

  * findOrderByInvoice({ locationId, code }) {
    return yield this.authorizedFetch(`/api/v1/location/${locationId}/OrderForInvoice`, {
      method: 'POST',
      body: JSON.stringify({ code }),
    });
  }

  * setDeliveryTime({ orderId, deliveryTime }) {
    return yield this.authorizedFetch(`/api/v1/order/${orderId}/set-delivery-time`, {
      method: 'POST',
      body: JSON.stringify({ deliveryTime }),
    });
  }
}

export default OrderApi;
